// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6ab5fc1c","395":"68aba783","453":"8c4c2bdb","732":"8cb53031","977":"5b5824e5","996":"156bd5bd"}[chunkId] + ".chunk.js";
};